import { useMemo } from 'react';
import Fuse from 'fuse.js';
import { useDevicesByType } from 'app/agriculture/queries/devices/useDevicesByType';
import { useGenericEntityFromId } from 'app/agriculture/queries/entities/useGenericEntityFromId';
import { useGetLevelSnapshot } from 'app/agriculture/routes/Devices/LevelMonitorList/hooks/useGetLevelSnapshot';

export function useLevelMonitorResults(textFilter: string) {
    const levelMonitors = useDevicesByType('Level Monitor');
    const getParent = useGenericEntityFromId();
    const getLevelSnapshot = useGetLevelSnapshot();

    const fuse = useMemo(
        () =>
            new Fuse(Array.from(levelMonitors.values()), {
                keys: [
                    { name: 'name', weight: 1 },
                    { name: 'externalId', weight: 0.2 },
                    {
                        name: 'snapshot.infrastructure.name',
                        weight: 0.6,
                        getFn: ({ infrastructureId }) => getParent(infrastructureId)?.name ?? '',
                    },
                    {
                        name: 'snapshot.percentageRemaining',
                        weight: 0.8,
                        getFn: (device) =>
                            `${getLevelSnapshot(device)?.percentageRemaining ?? '--'}%`,
                    },
                ],
            }),
        [levelMonitors, getParent, getLevelSnapshot],
    );

    return useMemo(
        () =>
            !textFilter
                ? Array.from(levelMonitors.values())
                : fuse.search(textFilter).map(({ item }) => item),
        [textFilter, fuse, levelMonitors],
    );
}
